import { GAME_ADMIN_RESOURCES, GAME_ADMIN_SCOPES, PAGE_NAMES } from 'constant';

export const makeServicesActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'Get Keys',
				id: 'getKeys',
				isEnabled: () => {
					return hasPermission({
						entity: GAME_ADMIN_RESOURCES.zookeeper,
						action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zookeeper]?.listKeys,
						appName,
						configPageName: PAGE_NAMES.gameAdmin
					});
				}
			},
			{
				name: 'Show Update Requests',
				id: 'getAllPendingZkUpdateReqs',
				isEnabled: () => {
					return hasPermission({
						entity: GAME_ADMIN_RESOURCES.zookeeper,
						action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zookeeper]?.getAllPendingZkUpdateReqs,
						appName,
						configPageName: PAGE_NAMES.gameAdmin
					});
				}
			}
		]
	};
};

export const makeUpdateReqsActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'Approve',
				id: 'approveUpdateReq',
				isEnabled: () => {
					return hasPermission({
						entity: GAME_ADMIN_RESOURCES.zookeeper,
						action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zookeeper]?.updateZKUpdateReq,
						appName,
						configPageName: PAGE_NAMES.gameAdmin
					});
				}
			},
			{
				name: 'Reject',
				id: 'rejectUpdateReq',
				isEnabled: () => {
					return hasPermission({
						entity: GAME_ADMIN_RESOURCES.zookeeper,
						action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zookeeper]?.updateZKUpdateReq,
						appName,
						configPageName: PAGE_NAMES.gameAdmin
					});
				}
			}
		]
	};
};

export const makeKeysActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'View Key',
				id: 'viewKey',
				isEnabled: () => {
					return hasPermission({
						entity: GAME_ADMIN_RESOURCES.zookeeper,
						action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zookeeper]?.getValueForKey,
						appName,
						configPageName: PAGE_NAMES.gameAdmin
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'addKey',
			isEnabled: () => {
				return hasPermission({
					entity: GAME_ADMIN_RESOURCES.zookeeper,
					action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zookeeper]?.updateKey,
					appName,
					configPageName: PAGE_NAMES.gameAdmin
				});
			}
		}
	};
};
